'use client';

import classNames from 'classnames';
import { ReactNode, useEffect, useState } from 'react';
import { HEADER_HEIGHT } from '@/components/Header/constants';

export const HeaderWrapper = ({
    children,
    isShowShadow = false,
}: {
    children: ReactNode;
    isShowShadow?: boolean;
}) => {
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 50) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <header
            className={classNames(
                'tw-bg-white tw-mx-auto tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-w-100 tw-z-[40] md:tw-z-[100] tw-transition-shadow tw-duration-[0.4s]',
                { 'tw-shadow-menuScroll': isShowShadow || isScrolled },
            )}
            style={{ height: `${HEADER_HEIGHT}px` }}
        >
            <div
                className={classNames(
                    'header-container',
                    'tw-py-[23px] tw-px-[15px] tw-mx-auto sm:tw-max-w-[540px] md:tw-max-w-[728px] lg:tw-max-w-[960px] xl:tw-max-w-[1080px]',
                )}
            >
                {children}
            </div>
        </header>
    );
};
